import { decamelizeKeys } from 'humps'
import isEmpty from 'lodash.isempty'

import { APP_NAME } from '@config/constants'
import { fromEntries } from '@core/helpers'

import { PRODUCT_SOURCE_TYPE } from '../constants'

import { sendEvent, setOptOut, setUserId, setUserProperties } from './amplitude'
import {
  MARKETING_QUERY_PARAMETERS,
  USER_GROUP_NAME,
  USER_GROUP_VALUES,
} from './constants'
import * as DEFINITIONS from './definitions'
import { flagModel, productModel } from './models'

export const pageView = (to, from) => {
  const event = {
    platform: APP_NAME,
    current_page: {
      page_type: to.pageType,
      params: to.params,
    },
  }

  // Navigating on the SPA
  if (from.pageType) {
    event.referrer = {
      page_type: from.pageType,
      params: from.params,
    }
    // First load
  } else {
    event.referrer = {
      url: document.referrer,
    }

    const marketingParameters = Object.entries(to.query).filter(([key]) =>
      MARKETING_QUERY_PARAMETERS.includes(key),
    )

    if (!isEmpty(marketingParameters)) {
      setUserProperties(fromEntries(marketingParameters))
    }
  }

  sendEvent(DEFINITIONS.PAGE_VIEW, event)
}

export const context = ({ flags = {}, abtest = {}, ...ctx }) => {
  setUserProperties({
    flags: flagModel(flags, ctx.country),
    abtest: flagModel(abtest, ctx.country),
    ...decamelizeKeys(ctx),
  })
}

export const resize = ({ breakpointName }) => {
  setUserProperties({ breakpoint: breakpointName })
}

export const gdpr = ({ analytics }) => {
  setOptOut(!analytics)
}

export const userContext = ({
  userId,
  merchantId,
  isStaff,
  lastOrderDate,
  numberOfOrders,
  lifetimeRevenue,
}) => {
  let groupValue = USER_GROUP_VALUES.CUSTOMER
  if (isStaff) {
    groupValue = USER_GROUP_VALUES.STAFF
  }
  if (merchantId !== null) {
    groupValue = USER_GROUP_VALUES.MERCHANT
  }

  setUserId(userId)

  setUserProperties(
    decamelizeKeys({
      lastOrderDate,
      numberOfOrders,
      lifetimeRevenue,
      [USER_GROUP_NAME]: groupValue,
    }),
  )
}

export const paymentSuccess = ({ payment, products }) => {
  let productRevenue = 0
  let quantity = 0

  products.forEach((product) => {
    productRevenue += Number(product.price) * Number(product.quantity)
    quantity += Number(product.quantity)

    sendEvent(
      DEFINITIONS.PURCHASE_PRODUCT,
      decamelizeKeys({
        order_id: payment.orderId,
        ...productModel(product),
      }),
    )
  })

  sendEvent(DEFINITIONS.PURCHASE_ORDER, {
    shipping_revenue: payment.shipping,
    swap_eligible: payment.swap,
    sponsorship: payment.code_parrain,
    commission: payment.commission,
    order_id: payment.orderId,
    product_revenue: productRevenue,
    product_quantity: quantity,
    payment_method: payment.paymentMethod,
    // Calculation of the product prices only (no fees etc.)
    $revenue: payment.revenue,
  })
}

export const click = (ctx) => {
  sendEvent(DEFINITIONS.CLICK, ctx)
}

export const productImpression = (product) => {
  const productInfos = productModel(product)
  // Due to heavy volumetry on this sourceType, and this is not planed for analysis yet,
  // Let's disable this source for now.
  if (productInfos.product_list === PRODUCT_SOURCE_TYPE.RESULTS) {
    return
  }

  sendEvent(DEFINITIONS.PRODUCT_IMPRESSION, productInfos)
}
